import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
declare function tos(): any;
@Component({
    selector: 'prof-onetrust-tos',
    templateUrl: './onetrust-tos.component.html',
    styleUrl: './onetrust-tos.component.scss',
    standalone: false
})
export class OnetrustTosComponent implements OnInit {
  constructor(private _translateService: TranslateService) {}

  title: string;
  private onDestroy$ = new Subject<void>();
  ngOnInit(): void {
    this._translateService
          .get('ONETRUST.tos')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (this.title = value));
    tos();
  }
}
